import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import FeaturedProducts from "./components/FeaturedProducts";
import TestimonialSection from "./components/TestimonialSection";
import ArticlesSection from "./components/ArticlesSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://hoobuy.christmas";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      "url": siteUrl,
      "name": "HoobuySpreadsheet",
      "alternateName": "Hoobuy Sheet",
      "description": "O guia mais completo de compras da China — produtos virais, preços baixos e fornecedores confiáveis organizados num hoobuyspreadsheet atualizado diariamente.",
      "inLanguage": "pt-PT",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${siteUrl}/?s={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "Organization",
      "@id": `${siteUrl}/#organization`,
      "url": siteUrl,
      "name": "HoobuySpreadsheet",
      "description": "Plataforma de curadoria de produtos chineses com fornecedores verificados e preços atualizados diariamente.",
      "logo": {
        "@type": "ImageObject",
        "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg",
        "width": "512",
        "height": "512"
      }
    },
    {
      "@type": "WebPage",
      "@id": `${siteUrl}/#webpage`,
      "url": siteUrl,
      "name": "HoobuySpreadsheet 2026 – O Guia Mais Completo de Compras da China",
      "description": "Descubra o melhor hoobuyspreadsheet 2026 com produtos virais, preços baixos e fornecedores confiáveis. Guia completo de compras da China com categorias organizadas.",
      "inLanguage": "pt-PT",
      "isPartOf": { "@id": `${siteUrl}/#website` },
      "about": { "@id": `${siteUrl}/#organization` }
    }
  ]
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <AboutSection />
      <FeaturedProducts />
      <TestimonialSection />
      <ArticlesSection />
      <CTASection />
      <Footer />
    </main>
  );
}